import { login, fetchUser } from '@/repositories/auth';
import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

import type { SignInResponse, ProfileResponse } from '@/types/api/auth';
import { StorageAuth } from '@/types/storage/auth';
import { HomeRouteName } from '@/types/router/name/home';

export const useAuthStore = defineStore('auth-store', {
    state: () => ({
        session: useLocalStorage<SignInResponse | null>(StorageAuth.Session, null, {
            serializer: {
                read: v => JSON.parse(v),
                write: v => JSON.stringify(v)
            }
        }),
        profile: {} as ProfileResponse | null
    }),

    getters: {
        canAccess: state => (reqPerm?: string | string[]) => {
            if (!reqPerm) return true;
            const userPermissions = state.profile?.permissions ?? [];
            if (userPermissions.includes('*.*')) return true;
            const requiredList = Array.isArray(reqPerm) ? reqPerm : [reqPerm];
            if (requiredList.includes('*.*')) {
                return false;
            }
            return requiredList.some(perm => userPermissions.includes(perm));
        }
    },

    actions: {
        async signIn(email: string, password: string): Promise<void> {
            try {
                const result = await login<SignInResponse>(email, password);
                this.session = result;
                const { default: router } = await import('@/router');
                router.push({ name: HomeRouteName.Home });
            } catch (error) {
                console.error(error);
                throw error;
            }
        },

        async getProfile() {
            try {
                const result = await fetchUser<ProfileResponse>();
                this.profile = result;
            } catch (error) {
                console.error(error);
            }
        }
    }
});
